import { mmToCm } from '~/utils/units';

export const DVF_SPACING_MM_MIN = 5;
export const DVF_SPACING_MM_MAX = 20;
export const DVF_SPACING_MM_DEFAULT = 15;
export const DVF_SPACING_MM_STEP = 5;

export const DVF_SPACING_CM_MIN = mmToCm(DVF_SPACING_MM_MIN);
export const DVF_SPACING_CM_MAX = mmToCm(DVF_SPACING_MM_MAX);
export const DVF_SPACING_CM_STEP = mmToCm(DVF_SPACING_MM_STEP);

export const DVF_SPACING_CM_PRECISION = 1;
